import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect } from 'react';
import { useFlag } from '@carnica/utils/hooks';
export var useNodeObserver = function useNodeObserver(_ref) {
  var ref = _ref.ref,
    callback = _ref.callback,
    options = _ref.options;
  var _useFlag = useFlag(),
    _useFlag2 = _slicedToArray(_useFlag, 2),
    triggered = _useFlag2[0],
    setIsTriggered = _useFlag2[1];
  useEffect(function () {
    var observer = null;
    if (ref) {
      observer = new IntersectionObserver(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 1),
          entry = _ref3[0];
        setIsTriggered.set(callback(entry));
      }, options);
      if (ref.current) {
        observer.observe(ref.current);
      }
    }
    return function () {
      if (observer) {
        observer.disconnect();
      }
    };
  });
  return triggered;
};